import React, { useState } from 'react';
import { AnchoredNotificationWarning } from '@noths/polaris-client-ribbons-design-system';

import { ErrorNotificationWrapper } from './ErrorNotificationWrapper';
import * as styles from './Error.styles';

export interface ErrorNotificationProps {
  errorMsg: string;
  setErrorState: React.Dispatch<React.SetStateAction<boolean>>;
}

const ERROR_NOTIFICATION_MESSAGE_ID = 'error-notification-message';

export const ErrorNotification = ({ errorMsg, setErrorState }: ErrorNotificationProps) => {
  const [isVisible, setIsVisible] = useState(true);

  return (
    <ErrorNotificationWrapper>
      <div
        aria-describedby={ERROR_NOTIFICATION_MESSAGE_ID}
        css={styles.addToBasketAlert}
        data-testid="error-notification"
        data-visible={isVisible}
        role="alertdialog"
      >
        <AnchoredNotificationWarning
          onClose={() => {
            setIsVisible(false);
            setErrorState(false);
          }}
        >
          <span css={styles.addToBasketAlertTextBox} id={ERROR_NOTIFICATION_MESSAGE_ID}>
            {errorMsg}
          </span>
        </AnchoredNotificationWarning>
      </div>
    </ErrorNotificationWrapper>
  );
};
